const isClient = typeof window !== 'undefined';
export class DomCustomEvent {
    initCustomEvent(typeArg, canBubbleArg, cancelableArg, detailArg) {
        this.type = typeArg;
        this.cancelable = cancelableArg;
        this.detail = detailArg;
    }
    composedPath() {
        return [];
    }
    initEvent(type, bubbles, cancelable) {
        this.type = type;
        this.bubbles = bubbles;
        this.cancelable = cancelable;
    }
    preventDefault() { }
    stopImmediatePropagation() { }
    stopPropagation() { }
    constructor(typeArg, eventInitDict) {
        this.bubbles = false;
        this.cancelable = false;
        this.composed = false;
        this.isTrusted = false;
        if (!isClient) {
            this.type = typeArg;
            this.detail = eventInitDict.detail;
            this.cancelable = eventInitDict.cancelable;
            return this;
        }
        const params = eventInitDict || { bubbles: false, cancelable: false, detail: undefined };
        const evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(typeArg, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
}
/**
 * 自定义事件，兼容部分浏览器和 nodejs 不能直接 new CustomEvent() 的问题
 */
export const CustomEvent = isClient && typeof window.CustomEvent === 'function' ? window.CustomEvent : DomCustomEvent;
